<template>
	<transition name="slide-up">
		<div class="cookiesbar bottom flex flex-vcenter" v-if="active">
			<div class="cookiesbar-text">
				Per offrirti il miglior servizio possibile Quomi utilizza cookies. Continuando la navigazione nel sito autorizzi l’uso dei
				<router-link :to="{name: 'cookies-policy'}"><u>cookies</u></router-link>.
			</div>
			<div class="close-btn" @click="close()">
				<span >Autorizzo</span>
			</div>
		</div>
	</transition>
</template>
<script>

import { container } from '../../services/container'

export default {
	data () {
		return {
			active: !container.get('services.cookies').get('cookielaw', '/')
		}
	},

	methods: {
		close () {
			this.active = false
			container.get('services.cookies').set('cookielaw', 1)
		},

		open () {
			this.active = true
		},

		scrollBehavior () {
			window.addEventListener('scroll', _ => {
				if (this.active === true) {
					this.close()
				}
			})
		}
	},

	mounted () {
		this.scrollBehavior()
	}
}

</script>

<style scoped>
a {
	color: white;
}

.bottom {
	bottom: 0%;
}

.cookiesbar{
	position: fixed;
	z-index: 9999999999;
	width: 100%;
	margin: 0 auto;
	background: rgba(47, 47, 47, 0.8);
	color: #fff;
	border: 0;
	justify-content: center;
	padding: 10px 50px;
	line-height: 1.5;
	border-radius: 0;
}

.cookiesbar-text {
	font-size: 12px;
	max-width: 900px;
	margin: 0 5px;
}

.cookiesbar .btn{
	padding: 0px 20px;
	margin: 4px;
	border-radius:3px !important;
	background-color: transparent;
	color: white;
}

.close-btn {
	border: 1px solid;
	font-size: 12px;
	padding: 5px;
	cursor: pointer;
	margin: 0 5px;
}

@media only screen and (max-width: 1024px) {
	.cookiesbar {
		padding: 5px;
		line-height: 1.1;
	}
}
</style>
